export default function formatPrice(n) {
  if (n == null || n === "") return "0";
  const num = Number(n);
  return Number.isFinite(num) ? num.toLocaleString("zh-TW") : String(n);
}
